import {App, Button as AntButton} from "antd";
import {configConfirmModal} from "@/theme/config/confirmModalConfirm";

export const Button = ({onClick, confirm, ...rest}) => {
    const {modal} = App.useApp();

    return (
        <>
            <AntButton
                {...rest}
                onClick={async () => {
                    if (confirm){
                        modal.confirm(configConfirmModal({
                            ...confirm,
                            onOk: () =>{
                                if (onClick){
                                    onClick()
                                }
                            }
                        }))
                    }else {
                        if (onClick){
                            onClick()
                        }
                    }
                }}
            />
        </>
    );
}